import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import ProductPromoOffers from './ProductPromoOffers';
import { showModal, hideModal } from '../../../actions/modal';
import PriceSavingInfoPopup from './PriceSavingInfoPopup';
import ProductUpdationPopup from './ProductUpdationPopup';
import ProductRemovalPopup from './ProductRemovalPopup';
import { getSizeDetail } from '../../actions/cart';
import { addProductToWishlist } from '../../../wishlist/actions/wishlist';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import {
  calculatePriceInfo,
  getAppliedPromoFiredMsg,
  addCustomerType
} from '../../../utils/products';
import { getDateRange } from '../../../edd/utils/getDateRange.js';
import { showErrorMessageInfo } from '../../../actions/shared/HTTPError';
import deleteFromCartAndAddToWishlist from './deleteFromCartAndAddToWishlist';
import {
  IsDealStart,
  IsDealEnd
} from '../../../components/common/DodCommonComponent/DodComponentFunctionality';
import {
  DealOfTheDayTag,
  DealOfTheDayTimerTag
} from '../../../components/common/DodCommonComponent/DodCommonComponent';
import { DealOfTheDayModal } from '../../../components/common/DodCommonComponent/DodModals';
import Modal from '../../../components/common/Modal';
import { fetchSizeAndBrandSize, beautyCheck } from '../../../utils/StandardSizeUtils';
import { getNewSizeRevampFlag, getShowBrandSizeFlag } from '../../../Flags/selectors.js';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { gtmEventPush, gtmSellerOptionClicked } from '../../../modules/ga/GTMdatalayer';
import { readCookie } from '../../../components/common/Cookie';
import { displayValueWithSymbol } from '../../../utils/price';
import { jioAdsAddtoWishList } from '../../../utils/jioAds';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import {
  computeReturnPolicyFlags,
  computeReturnMessages,
  getReturnPolicyIcons
} from '../../../utils/returnPolicyUtils';
import {
  getStoresForHidingMRP,
  getEnableRating,
  getEnableRatingLabelCart,
  getGiftWithProductEnable,
  getReturnCodCommunication,
  getEnableNonReturnableProductRevamp,
  getEnableNonReturnableProductRevampConfig,
  getMultiSellerSlaFlag,
  getMultiSellerSlaConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import AggregatedRatingTag from '../../../refresh/atoms/AggregatedRatingTag';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { FreebiesProductsItems } from '../../../components/common/Freebies/FreebiesGiftCard';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';
import { isExclusiveDatePast } from '../../../../src/utils/products';

const sizeObj = {
  XXS: 'Extra Extra Small',
  XS: 'Extra Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large',
  XXL: 'Extra Extra Large',
  'S/M': 'Small-Medium',
  'M/L': 'Medium-Large',
  'L/XL': 'Large-Extra Large'
};

const imageBaseUrl = properties.getProperty('imageBaseUrl');

/**
 * API priceType -> the key the priceType strip compares against.
 * Mirrors the msite copy in refresh/pages/CartPage/CartPage.tsx so both
 * platforms decide the note/CTA identically. Note this is deliberately NOT the
 * DeliverySLA molecule's normalizePriceType, which defaults unknown values to
 * "best"; here an unrecognised value must fall through and show no strip.
 */
const normalizePriceType = value => {
  const key = String(value || '')
    .trim()
    .toUpperCase()
    .replace(/-/g, '_');
  if (key === 'BEST_SPEED' || key === 'FASTEST') return 'fastest';
  if (key === 'BEST_PRICE' || key === 'BEST') return 'best';
  return String(value || '')
    .trim()
    .toLowerCase();
};

export function isEDDRequired(pageTitle) {
  switch (pageTitle) {
    case 'orderconfirm':
      return true;
    default:
      return false;
  }
}
export class CartProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.textResources = {
      moveClosetBtn: 'Move to Wishlist'
    };
    this.state = {
      alt: '',
      header: 'One Item Per Person',
      subText: 'Sale limited to one item per person',
      giftItemData: {}
    };
    this.modalFocusIntervalRef = React.createRef(null);
  }
  handleError(event) {
    event.target.src = `${properties.getProperty('imageBaseUrl')}/static/img/plp.png`;
  }
  sendAddToWithListDataGlinch = status => {
    const productDetails = this.props.product;
    const { code, quantity, size, priceInfo = {} } = productDetails;
    const { Price, Discount, CouponSaving } = calculatePriceInfo(priceInfo);
    const eventObj = [];
    eventObj.ProductId = code;
    eventObj.quantity = quantity;
    eventObj.size = size;
    eventObj.status = status;
    eventObj.Price = Price;
    eventObj.Discount = Discount;
    eventObj.CouponSaving = CouponSaving;
    const { pageId, pageType } = getPageInfo(location.pathname || '');
    eventObj.pageId = pageId;
    eventObj.pageType = pageType;
    sendEvent('MoveToCloset', eventObj);
  };
  handleSizeChange = (sizeClick = false, beautyVolume = '', hideSizes = false) => {
    const { product = {}, multiSellerSlaEnabled = false } = this.props;
    const { code, entryNumber, quantity = '', dealEnabled = false } = product;
    // Multiseller: the popup's deliveryChoices call already carries every size
    // with its stock, so sizeVariants (stockCheck) is not fetched.
    const fetchSizeVariants = () => {
      if (multiSellerSlaEnabled) return;
      this.props.getSizeDetail(code);
    };
    if (dealEnabled) {
      if (!sizeClick) {
        this.setState({
          ...this.state,
          header: 'One Item Per Person',
          subText: 'Sale limited to one item per person'
        });
        this.props.showModal('cart-one-item-per-person');
        return;
      }
    }
    !dealEnabled && sessionStorage.removeItem(`${code}`);
    if (sizeClick) {
      fetchSizeVariants();
      const timeout = setTimeout(() => {
        this.props.setModal({
          name: 'cart-qty',
          classes: 'cart-qty-update-modal',
          ariaLabel: "Select Size",
          content: (
            <ProductUpdationPopup
              priceInfo={product.priceInfo}
              quantity={quantity}
              entryNumber={entryNumber}
              code={code}
              updateQuantity={this.props.updateQuantity}
              modalName="cart-qty"
              dealEnabled={dealEnabled}
              beautyVolume={beautyVolume}
              hideSizes={hideSizes}
              itemData={product}
            />
          )
        });
        // ✅ Start watching for modal close
        this.startModalCloseWatcher("cartsize");
        clearTimeout(timeout);
      }, 1000);
    } else {
      fetchSizeVariants();
      this.props.setModal({
        name: 'cart-qty',
        classes: 'cart-qty-update-modal',
        ariaLabel: "Select Size",
        content: (
          <ProductUpdationPopup
            priceInfo={product.priceInfo}
            quantity={quantity}
            entryNumber={entryNumber}
            code={code}
            updateQuantity={this.props.updateQuantity}
            modalName="cart-qty"
            beautyVolume={beautyVolume}
            hideSizes={hideSizes}
            itemData={product}
          />
        )
      });
      // ✅ Start watching for modal close
      this.startModalCloseWatcher("cartqty");
      if (typeof ga === 'function') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Buttop tap',
          eventAction: 'Current event for clicking on "qty" button',
          eventLabel: 'Inventory change'
        });
      }
    }
  };

  /*
    Logic for focus return to trigerring element on the quantity and size button for accessibility 
   */
  startModalCloseWatcher = (returnButton) => {
    // Clear any existing interval first
    if (this.modalFocusIntervalRef.current) {
      clearInterval(this.modalFocusIntervalRef.current);
      this.modalFocusIntervalRef.current = null;
    }

    this.modalFocusIntervalRef.current = setInterval(() => {
      const modal = document.querySelector(
        '[role="dialog"].cart-qty-update-modal'
      );

      // If modal is still open → do nothing
      if (modal) return;

      // Modal is closed → restore focus
      const cartQtyButton = document.querySelector(
        `.${returnButton}[role="button"]`
      );

      if (cartQtyButton) {
        cartQtyButton.focus();
      }

      // Cleanup interval
      clearInterval(this.modalFocusIntervalRef.current);
      this.modalFocusIntervalRef.current = null;
    }, 200); // check every 5 seconds
  };

  componentWillUnmount() {
    if (this.modalFocusIntervalRef.current) {
      clearInterval(this.modalFocusIntervalRef.current);
      this.modalFocusIntervalRef.current = null;
    }
  }

  addWishlistInLocal = productCode => {
    const userId = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !userId || productCode === '') return false;
    const userWishlistData = wishlistData[userId];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(productCode)) codes.push(productCode);
    const localData = {
      updatedOn,
      codes
    };
    const finalResponse = wishlistData;
    finalResponse[userId] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
  };

  /**
   * "Faster delivery / Better price available" strip (desktop cart tile).
   *  - selectedPriceType best    → fastDeliveryNote + fastDeliveryTimeMessage[deliverySLA]
   *  - selectedPriceType fastest → betterPriceNote + betterPriceCta ("Check details")
   * Same rules as msite (see CartPage.renderPriceTypeStrip): priceType is
   * normalized (the API sends BEST_PRICE / BEST_SPEED, not best / fastest) and the
   * alternative's delivery fields are read flat with a servicabilityInfo fallback.
   */
  renderPriceTypeStrip = () => {
    const {
      product = {},
      multiSellerSlaEnabled = false,
      multiSellerSlaConfig = {},
      orderPageTitle = '',
      deviceType = '',
      newDesignLuxe = false,
      hasCartDeliveryLocation = false
    } = this.props;
    if (!multiSellerSlaEnabled || orderPageTitle || deviceType === 'msite') return null;
    // Nothing to compare against without an address or pincode on the cart.
    if (!hasCartDeliveryLocation) return null;

    const { unSelectedPrice = [] } = product;

    // The API sends BEST_PRICE / BEST_SPEED, not best / fastest — compare
    // normalized or neither branch matches and the strip never renders.
    const selectedPriceType = normalizePriceType(product?.selectedPriceType);
    if (!Array.isArray(unSelectedPrice) || unSelectedPrice.length === 0) return null;

    const {
      cartSwapEnabled = false,
      fastDeliveryNote = '',
      betterPriceNote = '',
      betterPriceCta = 'Check details',
      fastDeliveryTimeMessage = {}
    } = multiSellerSlaConfig || {};
    // Swapping the seller/price option from the cart tile is separately gated.
    if (!cartSwapEnabled) return null;

    let note = '';
    let cta = '';
    if (selectedPriceType === 'best') {
      note = fastDeliveryNote;
      const alternate = unSelectedPrice[0] || {};
      // deliverySLA / shippingAction come flat on the alternative, but fall back
      // to servicabilityInfo (the shape used on the selected option).
      const deliverySLA = alternate.deliverySLA || alternate.servicabilityInfo?.deliverySLA || '';
      const shippingAction =
        alternate.shippingAction || alternate.servicabilityInfo?.shippingAction || '';
      cta = fastDeliveryTimeMessage[deliverySLA] || '';
      // A BEST_SPEED alternative shipping STANDARD has no deliverySLA, so there
      // is no time message to show — fall back to the generic CTA.
      const isStandardNoSla =
        !deliverySLA &&
        String(shippingAction)
          .trim()
          .toUpperCase() === 'STANDARD' &&
        normalizePriceType(alternate.selectedPriceType) === 'fastest';
      if (!cta && isStandardNoSla) cta = betterPriceCta;
    } else if (selectedPriceType === 'fastest') {
      note = betterPriceNote;
      cta = betterPriceCta;
    }
    if (!note || !cta) return null;

    const { valueWithUnit: volume, hideSizes } = beautyCheck(product.variantOptionQualifiers);
    const openSizeModal = () => {
      const { cart: { screenName = '' } = {} } = luxeScreen;
      gtmSellerOptionClicked({
        item: product,
        size: volume || product.size,
        storeType: newDesignLuxe ? 'luxe' : 'ajio',
        screenName
      });
      this.handleSizeChange(true, volume, hideSizes);
    };
    return (
      <div
        className="cart-pricetype-strip"
        role="button"
        tabIndex={0}
        aria-label={`${note}. ${cta}`}
        onClick={openSizeModal}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openSizeModal();
          }
        }}
      >
        <span className="cart-pricetype-strip__note">{note}</span>
        <span className="cart-pricetype-strip__cta">{cta}</span>
      </div>
    );
  };

  freebiesItemsList = (props) => {
    const { giftItemData ={}, isLuxe=false } = props;
    const { giftQuantity=0,
      giftProducts: { quantities =[], associatedProducts=[] } ={}
    } = giftItemData;
    const productItems = quantities.map((item, i)=>{
      return {
        brandName: item.productTitle,
        imageUrl: item.image,
        mrp: item.mrp,
        quantity: item.qty,
        isReturnable: item.isReturnable
      }
    });
  
    return (
      <div>
        <div className={ `freebie-items-modal-title ${!isLuxe && 'border-bottom-freebie'}`}>{giftQuantity}{" "} Freebies</div>
        <div className='freebie-items-modal-div'>
          <FreebiesProductsItems
            products={productItems}
            isDesktop
            isLuxe={isLuxe}
          />
          {associatedProducts.length > 0 && (
            <div className='associatedProducts-div'>
              <p>On completing combo purchase of</p>
              <div className='freebie-add-image-div'>
                {
                  associatedProducts.map((item)=>{
                    return(
                      <div className='freebie-add-image'>
                        <img src={replaceWithJioCDN(item?.image)} alt="product image" height="44px" width="36px"/>
                      </div>
                    )
                  })
                }
              </div>
              <div></div>
          </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const {
      product = {},
      idx = '',
      isPageTitle = false,
      orderPageTitle = '',
      itemAvailabilty = {},
      newSizeRevampFlag,
      showBrandSizeFlag,
      appliedPromoFiredMsg = '',
      storesForHidingMRP,
      enableRating,
      enableRatingLabelCart,
      deliveryFeeTagInfo = {},
      displayDeliveryFeeTag = false,
      changeModalViewState,
      enableGiftWithProductFlag=false,
      isLuxe = false,
      returnCodCommunication = {},
      enableNonReturnableProductRevamp = false,
      isGSTSelected = false,
      revampConfig = {}
    } = this.props;
    const {
      brandName = '',
      code,
      catalogName,
      entryNumber,
      exclusiveTill = '',
      productTag = '',
      images = [],
      offers = {},
      name = '',
      priceInfo = {},
      quantity = '',
      size = '',
      brandSize = '',
      url,
      offers: { listVoucher = 0 } = {},
      altText,
      voucherMessages = '',
      baseProduct = '',
      eddUpper,
      eddLower,
      basePrice = {},
      dealEnabled = false,
      dealEndTime,
      dealType,
      actualDealStartTime,
      premiumDealStartTime,
      variantOptionQualifiers,
      brickCategory,
      averageRating,
      numUserRatings,
      brickSubCategory,
      brickName,
      isGiftProduct = false,
      giftQuantity=0,
      giftProducts: { quantities = [], associatedProducts = [] } = {},
      returnWindow = 0,
      isReturnable,
      isExchangeable,
      isCatalogFraudReturnable,
      isCatalogFraudExchangeable
    } = product;
    const { valueWithUnit: volume, hideSizes } = beautyCheck(variantOptionQualifiers);
    const productTagValue = isExclusiveDatePast(exclusiveTill)
      ? 'EXCLUSIVE'
      : productTag?.toLowerCase() !== 'exclusive'
      ? productTag
      : '';
    const { sizeUI: newSizeUI = '', brandSizeUI: newBrandSize = '' } = fetchSizeAndBrandSize(
      variantOptionQualifiers,
      newSizeRevampFlag
    );

    const brandSizeUI = showBrandSizeFlag ? newBrandSize || brandSize : '';
    const sizeUI = newSizeUI || size;
    
    function manageSizeName(tempSize) {
      if (sizeObj[tempSize]) {
        return sizeObj[tempSize];
      }
      return null;
    };

    function extractRange(tempSize) {

      // Match N followed by Y or M (e.g., "2Y" or "3M")
      let matchSingle = tempSize.match(/^(\d+)([YM])$/);
      // Match N-N followed by Y or M (e.g., "0-3Y" or "1-5M")
      let matchRange = tempSize.match(/^(\d+)-(\d+)([YM])$/);
      const unitMap = {
        Y: "year",
        M: "month"
      };

      if (matchSingle) {
        return {
          start: parseInt(matchSingle[1], 10),
          unit: unitMap[matchSingle[2]], // "Y" or "M"
        };
      }

      if (matchRange) {
        return {
          start: parseInt(matchRange[1], 10),
          end: parseInt(matchRange[2], 10),
          unit: unitMap[matchRange[3]], // "Y" or "M"
        };
      }

      // Not a valid format
      return null;
    }
    const sizeAriaLabel = extractRange(sizeUI)
    const sizeAriaLabel2 = manageSizeName(sizeUI)
    
    const {
      discountPercentage = '',
      originalPrice = '',
      netPrice = '',
      totalSaving = '',
      couponSaving = ''
    } = priceInfo;
    const itemAvailable =
      itemAvailabilty.availableQuantity < quantity ? itemAvailabilty.availableQuantity : false;
    let imageRender;
    if (images.length) {
      imageRender = images.map((imageData, i) => {
        if (imageData.format == 'mobileProductListingImage') {
          return (
            <Fragment>
              <img
                src={`${replaceWithJioCDN(imageData.url)}`}
                key={i}
                alt={imageData.altText || altText}
                title={imageData.altText || altText}
                onError={this.handleError}
              />

              {enableGiftWithProductFlag && isGiftProduct && <img style={{
                position: "absolute",
                bottom: "-69px",
                width: "36px",
                left: "-4px",
              }} src={`${imageBaseUrl}/static/img/${isLuxe ? 'FreeTagLuxe.svg' : 'FreeTag.svg'}`} alt="Free Tag" />}
            </Fragment>
          );
        }
        if (imageData.format == 'PRIMARY') {
          return (
            <Fragment>
              <img
                src={`${replaceWithJioCDN(imageData.url)}`}
                key={i}
                alt={imageData.altText || altText}
                title={imageData.altText || altText}
                onError={this.handleError}
              />
              {enableGiftWithProductFlag && isGiftProduct && <img style={{
                position: "absolute",
                bottom: "-69px",
                width: "36px",
                left: "-4px",
              }} src={`${imageBaseUrl}/static/img/${isLuxe ? 'FreeTagLuxe.svg' : 'FreeTag.svg'}`} alt="Free Tag" />}</Fragment>
          );
        }
      });
    } else {
      imageRender = (
        <img
          src={`${properties.getProperty('imageBaseUrl')}/static/img/plp.png`}
          key="broken-img"
          alt={altText}
          title={altText}
        />
      );
    }
    const isSignedIn = signInCheck();
    const priceTypeStrip = this.renderPriceTypeStrip();
    const { appliedVouchers = [], potentialPromotion = {}, appliedPromotion = {} } = offers;
    const potentialPromotionsTemp = potentialPromotion;
    const qtyClass = itemAvailable ? 'cartqty warning' : 'cartqty';
    const { deviceType = '', addToWishlistApi, deleteCard, showErrorMessageInfo } = this.props;
    const dateRange = getDateRange({ eddLower, eddUpper });
    // Deal of the Day
    const { isDealStart = false } =
      dealEnabled && actualDealStartTime ? IsDealStart(actualDealStartTime) : false;
    const { isDealEnd = true } = dealEnabled && dealEndTime ? IsDealEnd(dealEndTime) : false;
    const { confirmPageUrl = '', dealInventory = '' } = this.props;
    const isConfirmPage = confirmPageUrl.indexOf('/confirm') !== -1;
    const dodCartTimer =
      dealEnabled && isDealStart && !isDealEnd && !isConfirmPage ? (
        <div className="dodCartTimer">
          <div className="dodCartItemLeft">
            {dealInventory && dealInventory <= 20 ? `Only ${dealInventory} Item(s) left` : ' '}
          </div>
          <DealOfTheDayTimerTag
            dealOfTheDayProductTimer={dealEndTime}
            imagePath="/static/img/endsIn.png"
            isCartTimeOut
            showModal={this.props.showModal}
            modalName="cart-dod-time-up"
            alt="Timer icon"
          />
        </div>
      ) : (
        ''
      );
    let dealSessionData = {};
    let showPriceIncreaseMessage = false;
    let priceIncrease = '';
    if (dealEnabled && isDealStart && !isDealEnd) {
      dealSessionData = {
        dealPrice: netPrice.value,
        code
      };
      if (window.sessionStorage) {
        window.sessionStorage.setItem(`${code}`, JSON.stringify(dealSessionData));
      }
    } else if (window.sessionStorage) {
      const dealCartSessionPrice = JSON.parse(window.sessionStorage.getItem(`${code}`)) || {};
      const { code: sessionCode = '', dealPrice = '' } = dealCartSessionPrice;
      if (code === sessionCode) {
        if (dealPrice < netPrice.value) {
          showPriceIncreaseMessage = true;
          priceIncrease = netPrice.value - dealPrice;
          priceIncrease = Number.isInteger(priceIncrease)
            ? `${priceIncrease}.00`
            : parseFloat(priceIncrease).toFixed(2);
        }
      }
    }
    const priceChangeDOM = showPriceIncreaseMessage ? (
      <div className="priceIncDec">
        <div className="priceIncDec__icon">
          <span className="ic-PriceIncrease" />
        </div>
        <div className="priceIncDec__message">
          Price increase {displayValueWithSymbol(priceIncrease)}
        </div>
      </div>
    ) : null;
    const { newDesignLuxe } = this.props;
    const { handleGtmEvent } = this.props;
    {
      newDesignLuxe ? (this.textResources.moveClosetBtn = 'Move to Wishlist') : ' ';
    }
    const { cart: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
    const { deliveryFeeTag = '', isItemWithFreeDelivery = false } = deliveryFeeTagInfo;

    let returnPolicySection = null;
    if (
      deviceType !== 'msite' &&
      enableNonReturnableProductRevamp &&
      returnCodCommunication?.isCartEnabled &&
      (!orderPageTitle || orderPageTitle === 'orderconfirm')
    ) {
      const {
        fraudBlocksReturn,
        fraudBlocksExchange,
        gstBlocksExchange,
        exchangeBlocked
      } = computeReturnPolicyFlags(
        {
          returnWindow,
          isReturnable,
          isExchangeable,
          isCatalogFraudReturnable,
          isCatalogFraudExchangeable
        },
        isGSTSelected
      );

      const {
        returnMsg,
        exchangeMsg,
        returnAndExchangeMsg,
        messageNoReturnAndExchangeDesktop,
        messageNonReturnableDesktop,
        messageNoExchangeDesktop
      } = computeReturnMessages(revampConfig, returnWindow, false);

      const { nonReturnableTickSvg, nonReturnableCloseSvg } = getReturnPolicyIcons(imageBaseUrl);

      let returnPart = null;
      if (isReturnable && returnWindow > 0) {
        returnPart = (
          <>
            <img src={nonReturnableTickSvg} alt="return icon" />
            <span>{returnMsg}</span>
          </>
        );
      } else if (fraudBlocksReturn) {
        returnPart = (
          <>
            <span className="cart-return-policy-strikeout-wrapper">
              <img src={nonReturnableTickSvg} alt="return icon" />
              <span>{returnMsg}</span>
            </span>
            <img src={nonReturnableCloseSvg} alt="non returnable icon" />
            <span className="cart-return-policy-label">{messageNonReturnableDesktop}</span>
          </>
        );
      } else if (!isReturnable && (isExchangeable || fraudBlocksExchange)) {
        returnPart = (
          <>
            <img src={nonReturnableCloseSvg} alt="non returnable icon" />
            <span className="cart-return-policy-label">{messageNonReturnableDesktop}</span>
          </>
        );
      }

      let exchangePart = null;
      if (isExchangeable && returnWindow > 0 && !gstBlocksExchange) {
        exchangePart = (
          <>
            <img src={nonReturnableTickSvg} alt="exchange icon" />
            <span>{exchangeMsg}</span>
          </>
        );
      } else if (exchangeBlocked) {
        exchangePart = (
          <>
            <span className="cart-return-policy-strikeout-wrapper">
              <img src={nonReturnableTickSvg} alt="exchange icon" />
              <span>{exchangeMsg}</span>
            </span>
            <img src={nonReturnableCloseSvg} alt="no exchange icon" />
            <span className="cart-return-policy-label">{messageNoExchangeDesktop}</span>
          </>
        );
      }

      const noExchangePart =
        fraudBlocksReturn && !isExchangeable && !isCatalogFraudExchangeable ? (
          <>
            <img src={nonReturnableCloseSvg} alt="no exchange icon" />
            <span className="cart-return-policy-label">{messageNoExchangeDesktop}</span>
          </>
        ) : null;

      const hasStrikeout = fraudBlocksReturn || exchangeBlocked;

      if (!returnPart && !exchangePart && !noExchangePart) {
        returnPolicySection = (
          <div className="cart-return-policy-row">
            <img src={nonReturnableCloseSvg} alt="non returnable icon" />
            <span className="cart-return-policy-label">{messageNoReturnAndExchangeDesktop}</span>
          </div>
        );
      } else if (isReturnable && isExchangeable && returnWindow > 0 && !gstBlocksExchange) {
        returnPolicySection = (
          <div className="cart-return-policy-row">
            <img src={nonReturnableTickSvg} alt="return exchange icon" />
            <span>{returnAndExchangeMsg}</span>
          </div>
        );
      } else if (hasStrikeout) {
        returnPolicySection = (
          <>
            {returnPart && <div className="cart-return-policy-row">{returnPart}</div>}
            {(exchangePart || noExchangePart) && (
              <div className="cart-return-policy-row">
                {exchangePart}
                {noExchangePart}
              </div>
            )}
          </>
        );
      } else {
        returnPolicySection = (
          <div className="cart-return-policy-row">
            {returnPart}
            {exchangePart}
            {noExchangePart}
          </div>
        );
      }
    }
    return (
      <div className="card-offer">
          <Modal
            name="cart-one-item-per-person"
            className="dodModal"
            closeButton={false}
            disableOutsideClick
          >
            <DealOfTheDayModal
              alt='Error icon'
              logo="/static/img/modalFail.png"
              header={this.state.header}
              subText={this.state.subText}
              modalName="cart-one-item-per-person"
              hideModal={this.props.hideModal}
            />
          </Modal>
          <Modal name="cart-dod-time-up" closeButton={false} disableOutsideClick className="dodModal">
            <DealOfTheDayModal
              alt="Timer icon"
              logo="/static/img/timer.png"
              header="Time is up"
              timer
              subText="Sorry, deal is over. Although you can buy this product on an updated price"
              isStartIn={false}
              topTimerOrProductTimer={false}
              pageRefresh
              modalName="cart-dod-time-up"
            />
          </Modal>
          <div className={enableGiftWithProductFlag && giftQuantity> 0? 'freebies-cart-items-container' : ''}>
            {!orderPageTitle &&
            appliedVouchers
              .concat(Object.keys(potentialPromotion))
              .concat(Object.keys(appliedPromotion)).length > 0 ? (
            <ProductPromoOffers
                isPageTitle={isPageTitle}
                voucherMessages={voucherMessages}
                offers={offers}
                listVoucher={listVoucher}
                setModal={this.props.setModal}
                priceInfo={priceInfo}
                appliedPromoFiredMsg={appliedPromoFiredMsg}
              />
            ) : (
              ''
            )}

            {enableGiftWithProductFlag && giftQuantity> 0 && <div className='freebies-cart-items-text-block' onClick={()=>changeModalViewState(true, product)}>
              <img
                src={`${properties.getProperty('imageBaseUrl')}/static/img/freebie-gift${
                  isLuxe ? '-luxe' : ''
                }.svg`}
                alt={'freebie icon'}
                height={'20px'}
                width={'20px'}
              />
              <div className={isLuxe ? 'freebie-text-luxe' : 'freebie-text'}>
                {giftQuantity === 1 ? 'Freebies' : `${giftQuantity} Freebies`}
              </div>
              <img
                src={`${properties.getProperty('imageBaseUrl')}/static/img/forward-vector.svg`}
                alt={'forward-vector'}
                height={'20px'}
                width={'20px'}
              />
            </div>}
          </div>
  
          <Modal
            name="freebies-cart-modal"
            closeButton
            onClose={()=>changeModalViewState(false)}
            customClassName={"modal-bg-color"}
            alignToRight
            fullHeight
          >
          {this.freebiesItemsList({ ...product, giftItemData: this.props.giftItemData, isLuxe })}
          </Modal>

          {dodCartTimer}
          <div className="product-card">
            {itemAvailable && deviceType === 'msite' && (
              <div className="oos-qty">
                <span>
                  Please update the quantity. Only
                  {itemAvailable} left in stock
                </span>
              </div>
            )}
            <input type="hidden" name={`baseProductId_${idx}`} value={baseProduct} />
            <div className="card-section row" data-test='abc'>
            <Col xs={4} lg={2} className="product-img" role='link' tabIndex={0} aria-label={`${brandName} ${name}${volume ? ' | ' + volume : ''}. ${productTagValue || ''}`} onClick={()=>{
              window.location.href = addCustomerType(url)
            }}>
              <a href={addCustomerType(url)} aria-hidden="true" tabIndex={-1}>
                {imageRender}
                {productTagValue ? (
                    <div className="product-exclusive" aria-label={productTagValue}>{productTagValue}</div>
                  ) : null}
              </a>
              </Col>
              <Col xs={8} lg={10} className="product-details">
                <div className={`product-name${priceTypeStrip ? ' has-pricetype-strip' : ''}`}>
                  {newDesignLuxe && orderPageTitle === 'orderconfirm' ? (
                    <a href={addCustomerType(url)} aria-label={`${brandName} ${name}${volume ? ' | ' + volume : ''}`} aria-hidden='true' tabIndex={-1}>
                      <div className="mb-2" aria-label={brandName}>{brandName}</div>
                      <div aria-label={`${name}${!!volume ? "| " + volume : ""}`}>
                        {name}
                        {volume ? ` | ${volume}` : ''}
                      </div>
                    </a>
                  ) : (
                    <div>
                      <a href={addCustomerType(url)} aria-label={`${brandName} ${name}${volume ? ' | ' + volume : ''}`} aria-hidden='true' tabIndex={-1}>
                        <span>{brandName}</span> -{name}
                        {volume ? ` | ${volume}` : ''}
                      </a>
                      {enableRating && averageRating && enableRatingLabelCart && (
                        <AggregatedRatingTag
                          ratingValue={averageRating}
                          totalRatingCount={numUserRatings}
                          customClass="rating-label-desktop-cart"
                          backGroundColour={averageRating < 3 ? 'red' : 'green'}
                          size="lg"
                        />
                      )}
                    </div>
                )}
                  {displayDeliveryFeeTag && (
                    <div
                      className={
                        newDesignLuxe || !isItemWithFreeDelivery
                          ? 'delivery-fee-tag'
                          : 'delivery-fee-tag free-delivery'
                      }
                    >
                      {deliveryFeeTag}
                    </div>
                  )}
                  {orderPageTitle === 'orderconfirm' && returnPolicySection}
                  {priceTypeStrip}
                </div>
                <div className="update-wrapper">
                  {!orderPageTitle && !volume && !hideSizes ? (
                    <div
                      className="cartsize"
                      onClick={() => this.handleSizeChange(true)}
                      role="button"
                      tabIndex={0}
                    >
                      <span aria-label="Size">Size</span>
                      <div>
                        <span aria-label={sizeAriaLabel2 ? sizeAriaLabel2 : sizeAriaLabel ? `${sizeAriaLabel?.start}  ${sizeAriaLabel?.end ? 'to ' + sizeAriaLabel?.end : '' } ${sizeAriaLabel?.unit}` : sizeUI}><span aria-hidden="true">{sizeUI}</span></span>
                        {brandSizeUI ? (
                          <span id="brand-size" aria-label={`Brand Size ${brandSizeUI}`}>
                            (Brand Size <span className="size-format">{brandSizeUI}</span>)
                          </span>
                        ) : null}
                        <span className="ic-chevrondown" />
                      </div>
                    </div>
                  ) : (
                    <div className="cartsize">
                      {!!volume || hideSizes ? (
                        ''
                      ) : (
                        <span
                          className={newDesignLuxe && deviceType !== 'msite' && 'cartsize-grayspan'}
                          aria-label="Size"
                        >
                          Size
                        </span>
                      )}
                      {!!volume || hideSizes ? (
                        ''
                      ) : (
                        <div>
                          {sizeUI}
                          {brandSizeUI ? (
                            <span id="brand-size" aria-label={`Brand Size ${brandSizeUI}`}>
                              (Brand Size <span className="size-format">{brandSizeUI}</span>)
                            </span>
                          ) : null}
                        </div>
                      )}
                    </div>
                  )}
                  {!orderPageTitle ? (
                    <div
                      className={qtyClass}
                      onClick={() => this.handleSizeChange(false, volume, hideSizes)}
                      role="button"
                      tabIndex={0}
                    >
                      <span aria-label="Qty">Qty</span>
                      <div>
                        {quantity}
                        <span className="ic-chevrondown" />
                      </div>
                    </div>
                  ) : (
                    <div className={qtyClass}>
                      <span
                        className={newDesignLuxe && deviceType !== 'msite' && 'cartsize-grayspan'}
                        aria-label="Qty"
                      >
                        Qty
                      </span>
                      <div> {quantity}</div>
                    </div>
                  )}
                  {itemAvailable && deviceType !== 'msite' && (
                    <div className="oos-qty">
                      <span aria-label={`Please update the quantity. Only ${itemAvailable} left in stock`}>
                        Please update the quantity. Only
                        {itemAvailable} left in stock
                      </span>
                    </div>
                  )}
                </div>
              {!orderPageTitle && totalSaving.value > 0 && hideMRP ? (
                <Col
                  xs={12}
                  className={`product-saving ${dealEnabled &&
                    'addTopDueToDod'}`}
                  onClick={() => {
                    this.props.setModal({
                      name: 'product-saving',
                      classes: 'product-saving-modal',
                      content: <PriceSavingInfoPopup product={product} />,
                      ariaLabel: "Savings"
                    });
                  }}
                  role="button"
                  tabIndex={0}
                >
                  Savings :
                  <span className="cart-total-saving-text">
                    <strong>{totalSaving.formattedValue} </strong>
                    <span className="ic-chevrondown" />
                  </span>

                </Col>
              ) : null}
                {!dealEnabled ? priceChangeDOM : null}
                {!dealEnabled ? (
                  <div className="priceinfo">
                  <div
                    aria-label={
                      parseInt(discountPercentage) > 0 && hideMRP
                        ? `${displayValueWithSymbol(originalPrice.formattedValue)} strike off; ` +
                        `${parseInt(discountPercentage)}% discount available, ` +
                        `current price ${displayValueWithSymbol(netPrice.formattedValue)}.`
                        : `${displayValueWithSymbol(netPrice.formattedValue)}.`
                    }
                  >
                    {parseInt(discountPercentage) > 0 && hideMRP ? (
                      <div className="priceinfo-top" aria-hidden='true' tabIndex={-1}>
                        <div className="orignal-price">
                          {!newDesignLuxe && !orderPageTitle
                            ? originalPrice.formattedValue
                            : displayValueWithSymbol(originalPrice.formattedValue)}
                        </div>
                        {discountPercentage ? (
                          <>
                            {newDesignLuxe ? (
                              <div className="discount">({parseInt(discountPercentage)}% OFF)</div>
                            ) : (
                              <div className="discount">
                                ({parseInt(discountPercentage)}
                                %)
                              </div>
                            )}
                          </>
                        ) : null}
                      </div>
                    ) : null}
                    {Object.keys(potentialPromotion).length < 1 ? (
                      <div className="net-price best-price-strip" aria-hidden='true' tabIndex={-1}>
                        <strong>
                          {!newDesignLuxe && !orderPageTitle
                            ? netPrice.formattedValue
                            : displayValueWithSymbol(netPrice.formattedValue)}
                        </strong>
                      </div>
                    ) : (
                        <div className="net-price" aria-hidden='true' tabIndex={-1}>
                        <strong>
                          {!newDesignLuxe && !orderPageTitle
                            ? netPrice.formattedValue
                            : displayValueWithSymbol(netPrice.formattedValue)}
                        </strong>
                      </div>
                    )}
                  </div>
                  {!orderPageTitle && returnPolicySection}
                </div>
                ) : (
                  ''
                )}
              {!orderPageTitle && (
                <div
                  className={`product-delete ${isLuxe ? 'luxe-product-delete' : ''}`}
                  onClick={() => {
                    this.props.setModal({
                      name: 'cart-delete',
                      classes: 'cart-delete-modal',
                      content: (
                        <ProductRemovalPopup
                          product={product}
                          entryNumber={entryNumber}
                          code={code}
                          deleteCard={this.props.deleteCard}
                          addToCloset={this.props.addToWishlistApi}
                          modalName="cart-delete"
                          deviceType={deviceType}
                          newDesignLuxe={newDesignLuxe}
                          position={idx}
                          enableGiftWithProductFlag={enableGiftWithProductFlag}
                          isLuxe={isLuxe}
                        />
                      ),
                      ariaLabel: 'Delete from bag'
                    });
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {isPageTitle ? (
                    <div className="delete-btn" aria-label={newDesignLuxe ? 'Remove' : 'Delete'}>{newDesignLuxe ? 'Remove' : 'Delete'}</div>
                  ) : (
                    <span className="ic-delete" />
                  )}
                </div>
              )}
                {isPageTitle && (
                  <div
                    className={newDesignLuxe ? 'save-closet-btn' : 'save-closet-btn wishlist-icon-mr'}
                    onClick={() => {
                      if (isSignedIn) {
                        deleteFromCartAndAddToWishlist(
                          addToWishlistApi,
                          deleteCard,
                          'cart-delete',
                          code,
                          entryNumber,
                          showErrorMessageInfo,
                          '',
                          idx
                        );
                        newDesignLuxe &&
                          gtmEventPush({
                            event: 'Move_to_wishlist',
                            event_category: 'bag interactions',
                            event_action: 'move to wishlist',
                            event_label: readCookie('C'),
                            store_type: luxeStore,
                            page_type: screenType
                          });
                        this.addWishlistInLocal(baseProduct);
                        console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
                        console.log("TRACK POINT 3 ~ brickName:", brickName)
                        jioAdsAddtoWishList({
                          brickCategory: brickCategory || '',
                          brickSubCategory: brickSubCategory || '',
                          brickName: brickName || '',
                          code: baseProduct,
                          price: basePrice?.value,
                          quantity: 1
                        });
                      } else {
                        this.props.showModal('sign-in-up');
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    {!newDesignLuxe ? (
                      <span className="wishlist-icon-mr">
                        <img src={`${imageBaseUrl}/static/img/my-bag-wishlist-icon.svg`} alt='Wishlist icon'/>
                      </span>
                    ) : (
                      <span className="ic-wishlist" />
                    )}
                    {this.textResources.moveClosetBtn}
                  </div>
                )}
                {dealEnabled ? (
                  <div className="dodCartPrice">
                    <div className="dodCartPrice-section">
                      {parseInt(discountPercentage) > 0 ? (
                        <div className="dodCartPrice-discount">
                          ({parseInt(discountPercentage)}
                          %)
                        </div>
                      ) : null}
                      <div className="dodCartPrice-original-price">
                        {displayValueWithSymbol(originalPrice.formattedValue)}
                      </div>
                    </div>
                    <div className="dodCart-finalPrice" aria-label="Deal Price:">
                      Deal Price: <span> {displayValueWithSymbol(netPrice.formattedValue)}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </Col>
              {isEDDRequired(orderPageTitle) && dateRange && (
                <Col xs={12} className="estimated-time" aria-label={`Expected Delivery: ${dateRange}`}>
                  Expected Delivery:{' '}
                  <span className="estimated-time__date">
                    <strong>{dateRange}</strong>
                  </span>
                </Col>
              )}
          </div>
          </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { flags = {}, cart: { appliedProductPromotions = [] } = {} } = state;
  const { product: { entryNumber = -1, multiItemPromoAmt = 0 } = {} } = ownProps;
  const appliedPromoFiredMsg = getAppliedPromoFiredMsg(
    appliedProductPromotions,
    entryNumber,
    multiItemPromoAmt
  );
  const enableGiftWithProductFlag = getGiftWithProductEnable(flags);
  const isLuxe = getCurrentStore(state) === 'luxe';
  // Somewhere to deliver to: a selected address, or failing that the bare
  // `pinCode` the cart response carries at its root. With neither there is no
  // delivery/price comparison to offer, so the "Faster delivery / Better price"
  // strip stays hidden. deliveryAddress is always present on the normalized cart
  // and defaults to {}, hence the emptiness check rather than an existence one.
  const hasCartDeliveryLocation =
    Object.keys(state?.cart?.deliveryInfo?.deliveryAddress || {}).length > 0 ||
    Boolean(state?.cart?.pinCode);

  return {
    hasCartDeliveryLocation,
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    showBrandSizeFlag: getShowBrandSizeFlag(flags),
    appliedPromoFiredMsg,
    storesForHidingMRP: getStoresForHidingMRP(state),
    enableRating: getEnableRating(flags,state),
    enableRatingLabelCart: getEnableRatingLabelCart(state) === 'ON',
    appliedPromoFiredMsg,
    enableGiftWithProductFlag,
    isLuxe,
    returnCodCommunication: getReturnCodCommunication(state),
    multiSellerSlaEnabled: getMultiSellerSlaFlag(state),
    multiSellerSlaConfig: getMultiSellerSlaConfig(state),
    enableNonReturnableProductRevamp: getEnableNonReturnableProductRevamp(state),
    revampConfig: getEnableNonReturnableProductRevampConfig(state),
    isGSTSelected: (() => {
      const { orderPageTitle = '' } = ownProps;
      const gstDetails =
        orderPageTitle === 'orderconfirm'
          ? state?.order?.gstDetails || {}
          : state?.cart?.gstDetails || {};
      return gstDetails?.constructor === Object && Object.keys(gstDetails).length > 0;
    })()
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showErrorMessageInfo: error => {
      dispatch(showErrorMessageInfo(error));
    },
    getSizeDetail: code => {
      dispatch(getSizeDetail(code));
    },
    addToWishlistApi: (productId, showMessage) =>
      dispatch(addProductToWishlist(productId, showMessage))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CartProductCard);